import profile1 from '../assets/profile1.png'
import profile2 from '../assets/profile2.png'

export const TestimonialsData = [
    {
        image : profile1,
        comment: " Lets face it, AxiShop is the all time best in customer relations. Nothing beats their gentle customer service.",
        name: "Kazuna Cobalt"
    },
    {
        image : profile2,
        comment: " This shop is the absolute worst, I couldnt get exactly the products i ordered. I wont recommend at all.",
        name: "Natasha"
    },
    {
        image : profile1,
        comment: "I got what I want. There's so much unique stuff to choose from. AxiShop saved my life!.",
        name: "Alex Hormonzi"
    },
    {
        image : profile1,
        comment: " You are most likely to get a foundation that will really mask your skin shade here than on Amazon..",
        name: "John Alendon"
    },
    {
        image : profile2,
        comment: " Right up there with the stars. AxiShop better be around when i turn 85. They are the best!",
        name: "Beyonce"
    },
    {
        image : profile1,
        comment: " This store is the absolute best in overall skin care products. My Mum was beaming on her birthday!.",
        name: "Peter Obi"
    }
]